import React,{useState, useEffect, useRef} from "react";
import './Home.css';
import {
    motion,
    useScroll,
    useSpring,
    useTransform,
    useMotionValue,
    useVelocity,
    useAnimationFrame
  } from "framer-motion";
  import { wrap } from "@motionone/utils";

interface ParallaxProps {
children: string;
baseVelocity: number;
}
function ParallaxText({ children, baseVelocity = 100 }: ParallaxProps) {
    const baseX = useMotionValue(0);
    const { scrollY } = useScroll();
    const scrollVelocity = useVelocity(scrollY);
    const smoothVelocity = useSpring(scrollVelocity, {
      damping: 50,
      stiffness: 400
    });
    const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
      clamp: false
    });
  
    /**
     * This is a magic wrapping for the length of the text - you
     * have to replace for wrapping that works for you or dynamically
     * calculate
     */
    const x = useTransform(baseX, (v) => `${wrap(-20, -45, v)}%`);
  
    const directionFactor = useRef<number>(1);
    useAnimationFrame((t, delta) => {
      let moveBy = directionFactor.current * baseVelocity * (delta / 1000);
  
      /**
       * This is what changes the direction of the scroll once we
       * switch scrolling directions.
       */
      if (velocityFactor.get() < 0) {
        directionFactor.current = -1;
      } else if (velocityFactor.get() > 0) {
        directionFactor.current = 1;
      }
  
      moveBy += directionFactor.current * moveBy * velocityFactor.get();
  
      baseX.set(baseX.get() + moveBy);
    });
  
    /**
     * The number of times to repeat the child text should be dynamically calculated
     * based on the size of the text and viewport. Likewise, the x motion value is
     * currently wrapped between -20 and -45% - this 25% is derived from the fact
     * we have four children (100% / 4). This would also want deriving from the
     * dynamically generated number of children.
     */
    return (
      <div className="parallax">
        <motion.div className="scroller" style={{ x }}>
          <span className="parallel-text">{children} </span>
          <span className="parallel-text">{children} </span>
          <span className="parallel-text">{children} </span>
          <span className="parallel-text">{children} </span>
        </motion.div>
      </div>
    );
  }


const words = ["नमस्ते", "ഹലോ","வணக்கம்","Hello","It's Me!"];


function Home() {

    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [blink, setBlink] = useState(true);
    const [reverse, setReverse] = useState(false);

    // typeWriter
    useEffect(() => {
        if (index === words.length - 1 && subIndex === words[index].length) {
            return;
        }

        if (
            subIndex === words[index].length + 1 &&
            index !== words.length - 1 &&
            !reverse
        ) {
            setReverse(true);
            return;
        }

        if (subIndex === 0 && reverse) {
            setReverse(false);
            setIndex((prev) => prev + 1);
            return;
        }

        const timeout = setTimeout(() => {
            setSubIndex((prev) => prev + (reverse ? -1 : 1));
        }, Math.max(reverse ? 75 : subIndex === words[index].length ? 2000 :
            150, parseInt(Math.random() * 350)));

        return () => clearTimeout(timeout);
    }, [subIndex, index, reverse]);

    // blinker
    useEffect(() => {
        const timeout2 = setTimeout(() => {
            setBlink((prev) => !prev);
        }, 500);
        return () => clearTimeout(timeout2);
    }, [blink]);
    return (
        <>
        <div className="home">
            <div className="main-logo">
                <img className="main-logo-img" alt='logo' src='/Assets/main-logo.png'></img>
            </div>
            <div className="user-img">
                <img className="user-photo" src='/Assets/mayank-img4.png' alt="userImg"></img>
            </div>
            <div className="user-content">
                <div className="user-name">
                {`${words[index].substring(0, subIndex)}${blink ? "|" : " "}`}<br></br>
                    Mayank
                </div>
                <div className="user-description">
                    I'm an Indian developer and UI/UX designer. Open to work for full-time roles and freelance projects.
                </div>
                <div className="user-social-media">
                    <div className="social-media-container">
                    <a href="https://www.linkedin.com/in/mayank-gupta-715210242" target="_blank" rel="noreferrer">
                        <img src='/Assets/linkedin.svg' alt='linkedIn' className="icons"></img>
                    </a>
                    </div>
                    <div className="social-media-container">
                        <a href="https://x.com/mayankgupt_a" target="_blank" rel="noreferrer">
                            <img src='/Assets/twitter.svg' alt='linkedIn' className="icons"></img>
                        </a>
                    </div>
                    <div className="social-media-container">
                        <a href="https://github.com/71203mayank" target="_blank" rel="noreferrer">
                            <img src='/Assets/github.svg' alt='linkedIn' className="icons"></img>
                        </a>
                    </div>
                    <div className="social-media-container">
                        <img src='/Assets/dribble.svg' alt='linkedIn' className="icons"></img>
                    </div>

                </div>
                
            </div>
        </div>
        {/* <marquee width="100%" direction='left' scrollamount="5"> Scroll to Explore</marquee> */}
        <section>
      <ParallaxText baseVelocity={-5}>Scroll <span className="scroller-span">to</span> <span style={{color:"#ffcb74", paddingRight:"100px"}}>Explore</span></ParallaxText>
      {/* <ParallaxText baseVelocity={5}>Scroll velocity</ParallaxText> */}
    </section>
        </>
    );
}

export default Home;